export default "__VITE_ASSET__6TDuIazU__"